export enum NameInLegendOption {
    name = 'name',
    ticker = 'ticker',
    nameAndTicker = 'name_and_ticker',
}

/**
 * Timerange for which data is displayed
 */
export enum ChartDateZoom {
    CHART_ZOOM_ONE_DAY = '1d',
    CHART_ZOOM_FIVE_DAY = '5d',
    CHART_ZOOM_TEN_DAY = '10d',
    CHART_ZOOM_ONE_MONTH = '1m',
    CHART_ZOOM_THREE_MONTH = '3m',
    CHART_ZOOM_SIX_MONTH = '6m',
    CHART_ZOOM_ONE_YEAR = '1',
    CHART_ZOOM_TWO_YEAR = '2',
    CHART_ZOOM_THREE_YEAR = '3',
    CHART_ZOOM_FIVE_YEAR = '5',
    CHART_ZOOM_TEN_YEAR = '10',
    CHART_ZOOM_FIFTEEN_YEAR = '15',
    CHART_ZOOM_YTD = 'ytd',
    CHART_ZOOM_MAX = 'max',
}

export enum ChartSortColumn {
    NAME = 'name',
    OWNER = 'owner',
    USER_MODIFY_DATE = 'modify_date',
}

export enum ChartDropdownOption {
    PREVIEW = 'preview',
    SHARE = 'share',
    RENAME = 'rename',
    MOVE = 'move',
    DELETE = 'delete',
}
